module.exports = __webpack_public_path__ + "img/ampel_pin_grau.7967178e.svg";